export default __webpack_public_path__ + "static/media/knowledge-image.5d06c8cc.png";